import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const MaleIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    width="11px"
    height="24px"
    viewBox="0 0 11 24"
    fill="none"
    data-testid="male-icon"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.51017 5.99987C7.0894 5.99987 8.36963 4.65675 8.36963 2.99993C8.36963 1.34312 7.0894 0 5.51017 0C3.93093 0 2.6507 1.34312 2.6507 2.99993C2.6507 4.65675 3.93093 5.99987 5.51017 5.99987ZM2.6507 7.5H8.36962C9.55405 7.5 10.5142 8.50736 10.5142 9.75V14.25C10.5142 15.4927 9.55405 16.5 8.36962 16.5V22.5C8.36962 23.3284 7.72951 24 6.93989 24H4.08043C3.29081 24 2.6507 23.3284 2.6507 22.5V16.5C1.46627 16.5 0.506104 15.4927 0.506104 14.25V9.75C0.506104 8.50736 1.46627 7.5 2.6507 7.5Z"
      fill="currentColor"
    />
  </Icon>
);
